import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Circle, Path, Svg } from 'react-native-svg';
import { withUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface GlobeIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const ThemedSvg = withUnistyles(Svg);

const GlobeIcon = ({
  size = 20,
  color = 'iconPrimary',
  ...props
}: GlobeIconProps) => (
  <ThemedSvg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    uniProps={(t) => ({ color: t[color] })}
    {...props}
  >
    <Circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
    <Path d="M3 12H21" stroke="currentColor" strokeWidth="1.5" />
    <Path
      d="M12 3C14.5 5.5 15.75 8.75 15.75 12C15.75 15.25 14.5 18.5 12 21C9.5 18.5 8.25 15.25 8.25 12C8.25 8.75 9.5 5.5 12 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </ThemedSvg>
);

GlobeIcon.displayName = 'GlobeIcon';
export { GlobeIcon };
